module.exports = __webpack_public_path__ + "img/smc-logo.c956f4fa.png";